import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Site } from '../../../../models/site';
import { InspectionModule } from '../../../../enums/inspection-module';
import { SiteService } from '../../../../services/site.service';
import {
  selectSite
} from '../../../../features/site/site.actions';
import { Observable } from 'rxjs';
import {
  selectAdvancedFeaturesActivatingBySiteId,
  selectAdvancedFeaturesAvailableBySiteId,
  selectSiteById
} from '../../../../features/site/site.selectors';
import { SiteStatus } from '../../../../enums/site';

@Component({
    selector: 'site-card',
    templateUrl: './site-card.component.html',
    styleUrls: ['./site-card.component.scss'],
    standalone: false
})
export class SiteCardComponent {

  private _siteId!: string;

  advancedFeaturesAvailable$!: Observable<boolean>;
  advancedFeaturesActivating$!: Observable<boolean>;
  siteStatus = SiteStatus;


  @Input({ required: true })
  set siteId(value: string) {
    this._siteId = value;
    this.site$ = this.store.select(selectSiteById(value));
    this.advancedFeaturesAvailable$ = this.store.select(selectAdvancedFeaturesAvailableBySiteId(value));
    this.advancedFeaturesActivating$ = this.store.select(selectAdvancedFeaturesActivatingBySiteId(value));
  }
  site$!: Observable<Site | undefined>;
  inspectionModule = InspectionModule;

  constructor(private store: Store,
              private siteService: SiteService) {
  }

  onClickFlyToSite(site: Site) {
    this.siteService.flyTo(site);
  }

  onClickSelectSite(site: Site) {
    this.store.dispatch(selectSite({siteId: site.id}));
  }

  hasDetections(site: Site): boolean {
    return (site.detectionSummary?.detectionCount ?? 0) > 0;
  }

  hasVolumes(site: Site): boolean {
    return (site.volumeSummary?.densityPeak ?? 0) > 0;
  }
}
